import { Component } from '@angular/core';

import { ButtonColor } from '@freelancer/ui/button/button.component';

@Component({
  selector: 'app-navigation-secondary-contests',
  template: `
    <app-bar
      i18n-title="Secondary navigation contest bar title"
      title="Contests"
      link="/contest"
      flTrackingSection="SubnavContests"
    >
      <app-bar-item link="/contest"
        [exactLink]="true"
        i18n="Secondary navigation contest bar item"
        flTrackingLabel="Overview"
      >
        Overview
      </app-bar-item>
      <app-bar-item link="/contest/create.php"
        [exactLink]="true"
        i18n="Secondary navigation contest bar item"
        flTrackingLabel="GoToPostContest"
      >
        Start a Contest
      </app-bar-item>
      <app-bar-item
        link="/contest/browse"
        i18n="Secondary navigation contest bar item"
        flTrackingLabel="BrowseContests"
      >
        Browse Contests
      </app-bar-item>
      <app-bar-item link="/showcase"
        [exactLink]="true"
        i18n="Secondary navigation contest bar item"
        flTrackingLabel="Showcase"
      >
        Showcase
      </app-bar-item>
      <app-bar-item link="/contest-info"
        [exactLink]="true"
        i18n="Secondary navigation contest bar item"
        flTrackingLabel="LearnMore"
      >
        Learn More
      </app-bar-item>
      <fl-button
        [color]="ButtonColor.PRIMARY"
        link="/contest/create.php"
        i18n="Secondary navigation contest bar project contest button"
        flTrackingLabel="GoToPostContest"
      >
        Start a Contest
      </fl-button>
    </app-bar>
  `,
})
export class NavigationSecondaryContestsComponent {
  ButtonColor = ButtonColor;
}



// WEBPACK FOOTER //
// ./src/app/navigation-secondary/navigation-secondary-contests.component.ts